import { API_MODE } from '../api/client.js';

/** 小芯片：右上角告诉用户当前是 mock 还是 real */
export function ApiModeBadge() {
  const real = API_MODE === 'real';
  return (
    <span
      className={'api-mode-badge ' + (real ? 'real' : 'mock')}
      title={real ? '已切到真实 BFF（VITE_API_MODE=real）' : '默认 mock 模式，BFF 不会被调用'}
    >
      <span className="dot" />
      {real ? 'real' : 'mock'}
    </span>
  );
}
